import { ChangeDetectorRef, Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../services/notifications.service';
import { SpinnerService } from '../../services/spinner.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ScheduleEventDialogComponent } from '../schedule-event-dialog/schedule-event-dialog.component'
import { UserService } from '../../services/user.service';
import { Event } from '../../models/event'
import { ICanDeactivate } from '../../guards/can-deactivate-interface';
import { config } from '../../../assets/config-constant';
import {DefaultPreferenceRequest} from 'src/app/models/defaultPreferenceRequest';
import { Category } from 'src/app/models/category';
import jsonData from '../../../assets/i18n/en.json';
import * as _ from 'lodash';


@Component({
  selector: 'app-notification-preference',
  templateUrl: './notification-preference.component.html',
  styleUrls: ['./notification-preference.component.scss'],
  standalone: false,
})



export class NotificationPreferenceComponent implements OnInit, OnDestroy, ICanDeactivate {
  @HostListener('window:beforeunload')
  handleKeyboardEvent() {
    return this.notificationService.isChanged ? confirm() : true;
  }


  /*
 This property is to store user preferences
 */
  userPreferenceArr: any = [];

  /*
 This property is to store categories of notification
 */
  categories: any[] = [];

  /*
 This property is to store events of notification
 */
  events: Event[] = [];

  /*
This property is to store name of the selected application
*/
  appName: string | undefined = "";

  /*
This property is to store columns of events table
*/
  displayedColumns: string[] = [];

  /*
 This property is to store category selected by tab click
 */
  selectedCategory: string = "";

  /*
This property is to maintain all selected state of checkbox
*/
  allComplete: boolean = false;

  /*
 This property is to maintain indeterminate state of checkbox
 */
  isIndeterminate: boolean = false;

  /*
This property is to store the application Id from the route
*/
  applicationId: string = null;

  /*
This property is to store the request object for default prefrence
*/
  defaultPreferenceRequestObj: DefaultPreferenceRequest

  /*
 This property is to maintain state of save button
 */
  disableSaveAndCancel: boolean = true;

  /*
  This property is to hold only the changed events to save.
  */
  changedUserPrefEvents: Event[] = [];

  /*
  This property is to hold user id.
  */
  userId: string = "";

  /*
  This property is to hold events that are edited and ready to save.
  */
  userPrefList: any[] = [];

  /*
  This property is to hold already saved preferences.
  */
  savedUserPrefArr: any[] = [];

  /*
 This property is to hold searched key char.
 */
  searchTerm: string = "";

  /*
 This property is to hold searched key word after enter is pressed.
 */
  searchValue: string = "";

  /*
 This property is a dictionary to hold events count in category when searched.
 */
  countedEvents = new Map<string, number>();

  // Holds the array of days
  dayOfTheWeek: string[] = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ]

  userTimezoneOffset: number = 0;
  canUserEdit:boolean = true;
  isLoading = true;


  originalEvents: any = [];
  Headers: any;

  constructor(
    public notificationService: NotificationService,
    private actRoute: ActivatedRoute,
    private route: Router,
    public dialog: MatDialog,
    public userService: UserService,
    private readonly cdr: ChangeDetectorRef,
    private readonly spinner: SpinnerService) {
    this.notificationService.isChanged = false;
    this.Headers = jsonData;
    this.spinner.setPageOwnsLoader(true);
  }

  ngOnDestroy(): void {
    this.spinner.setPageOwnsLoader(false);
  }

  DetectChanges(): boolean {
    return this.notificationService.isChanged;
  }

  ngOnInit(): void {
    this.userService.getCurrentUser();
    this.userTimezoneOffset = new Date().getTimezoneOffset()
    this.userService.user$.subscribe((user) => {
      this.applicationId = this.actRoute.snapshot.params.id;
      this.userId = user.authId;
      if (this.notificationService.applicationDetails.length == 0) {
        this.notificationService.getApplications(this.userId).subscribe((response: any) => {
          this.appName = response.find(data => data.id == this.applicationId)?.applicationName;
          if(this.appName)
          {
            sessionStorage.setItem("appName", this.appName);
            this.fetchUserPref(this.userId);
          }
          else
          {
            this.route.navigate(["/notification"]);
          }
        });
      }
      else
      {
        this.appName = this.notificationService.applicationDetails.find(f=>f.id == this.applicationId)?.applicationName;
        if(this.appName)
        {
          this.fetchUserPref(this.userId);
        }
        else
        {
          this.route.navigate(["/notification"]);
        }
      }
    });
    this.displayedColumns = ['eventName', 'email', 'frequencyMode'];
    this.disableSaveAndCancel = true;
    this.searchTerm = "";
    sessionStorage.removeItem('categoryName');
  }

  /**
   * This method is used to open the scheduling popup
   * @param event
   * @param data
   */
  openDialog(event: any, data: any) {

    if (event && data) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        frequency: data.frequencyMode,
        time: data.frequencyTime,
        day: data.deliveryDay
      };
      dialogConfig.autoFocus = false;
      const dialogRef = this.dialog.open(ScheduleEventDialogComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (!result.event) {
            result.data && result.data.scheduleCategoryAllEvents ? this.changeFrequencyToAll(data, result) : this.changeEventFrequency(data, result);
            if (this.changedUserPrefEvents.length >= 1) {
              this.checkChanges();
            }
            this.cdr.detectChanges();
          }
        }
      });
    }
  }

  OpenScheduleAllDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxWidth = 660;
    dialogConfig.minHeight = 360;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(
      ScheduleEventDialogComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (!result.event) {
          this.changeGlobalFrequency(result);
          if (this.changedUserPrefEvents.length >= 1) {
            this.checkChanges();
          }
          this.cdr.detectChanges();
        }
      }
    });
  }

  changeGlobalFrequency(result) {
    this.categories.forEach((category) => {
      category.events.forEach((event) => {
        if (event?.canUserEdit && event?.email) {
          let existingEve = undefined;
          event.email = true;
          event.frequencyMode = result.data.frequencyMode;
          event.frequencyTime = result.data.frequencyTime;
          event.deliveryDay = result.data.deliveryDay;
          existingEve = this.changedUserPrefEvents.find(
            (preferredEvent) => preferredEvent.id == event.id
          );
          if (existingEve) {
            existingEve.email = true;
            existingEve.FrequencyMode = result.data.frequencyMode;
            existingEve.FrequencyTime = result.data.frequencyTime;
            existingEve.DeliveryDay = result.data.deliveryDay;
          } else {
            this.changedUserPrefEvents.push(event);
          }
        }
      });
    });
    this.fetchEvents(this.selectedCategory);
  }

  /*
  This method will change the frequency mode,time&day to all the events in that category
  */
  changeFrequencyToAll(data, result) {
    this.categories.forEach((category) => {
      if (category.categoryName === this.selectedCategory) {
        category.events.forEach((event) => {
          if (!event.canUserEdit) return;
          let existingEve = undefined;
          event.email = true;
          event.frequencyMode = result.data.frequencyMode;
          event.frequencyTime = result.data.frequencyTime;
          event.deliveryDay = result.data.deliveryDay;
          existingEve = this.changedUserPrefEvents.find(
            (preferredEvent) => preferredEvent.id == event.id
          );
          if (existingEve) {
            existingEve.FrequencyMode = result.data.frequencyMode;
            existingEve.FrequencyTime = result.data.frequencyTime;
            existingEve.DeliveryDay = result.data.deliveryDay;
          } else {
            this.changedUserPrefEvents.push(event);
          }
        });
      }
    });
    this.fetchEvents(this.selectedCategory);
    this.setAll(true);
  }

  /*
  This method will change the frequency mode,time&day to only selected event
  */
  changeEventFrequency(data, result) {
    let event = undefined;
    this.categories.forEach((category) => {
      if(category.categoryName === this.selectedCategory){
        category.events.forEach((e) => {
          if(data.id === e.id)
          {
            event = e;
          }
        });
      }
    });

    event.frequencyMode = result.data.frequencyMode;
    event.frequencyTime = result.data.frequencyTime;
    event.deliveryDay = result.data.deliveryDay;
    let existingEve = this.changedUserPrefEvents.find(
      (preferredEvent) => preferredEvent.id == data.id
    );
    if (existingEve) {
      existingEve.frequencyMode = result.data.frequencyMode;
      existingEve.frequencyTime = result.data.frequencyTime;
      existingEve.deliveryDay = result.data.deliveryDay;
    } else {
      this.changedUserPrefEvents.push(event);
    }
    this.fetchEvents(this.selectedCategory);
  }

  /**
   * This method is used to fetch saved user preferences as well as default user preferences.
   * @param type
   */
  fetchUserPref(userId: string) {
    this.userPreferenceArr = [];
    this.categories = [];
    this.events = [];
    this.defaultPreferenceRequestObj = {
      ApplicationId: this.applicationId,
      EventId: [],
      RoleId: [],
      UserId: '',
    };

    //1.call default pref
    this.notificationService
      .getDefaultUserPref(
        this.defaultPreferenceRequestObj
      )
      .subscribe((defaultPrefResponse: any) => {
        if (defaultPrefResponse.data) {
          this.userPreferenceArr.push(defaultPrefResponse.data);
        }
        if (this.userPreferenceArr.length > 0) {
          this.userPreferenceArr.forEach(defaultElement => {
            defaultElement.categories.forEach(category => {
              if (
                this.categories.findIndex(
                  f => f.categoryName == category.categoryName
                ) == -1
              ) {
                this.categories.push(category);
              }
            });
          });
        }
        //2.fetch saved user pref events
        if (this.categories.length > 0) {
          this.notificationService
            .getSavedUserPref(this.applicationId, this.userTimezoneOffset)
            .subscribe((response: any) => {
              this.mergePref(response.data);
              this.isLoading = false;
              this.spinner.setPageOwnsLoader(false);
              this.cdr.detectChanges();
            });
        } else {
          this.isLoading = false;
          this.spinner.setPageOwnsLoader(false);
          this.cdr.detectChanges();
        }
      });
  }

  mergePref(userPreferenceList) {
    this.savedUserPrefArr = userPreferenceList;
    //3.Merge events that has saved pref with default pref
    userPreferenceList.forEach((userPref) => {
      this.categories.forEach((category) => {
        category.events.forEach((event) => {
          if (event.eventId == userPref.eventId && event.canUserEdit) {
            event.email = userPref.sendEmail;
            event.sms = userPref.sendSms;
            event.badge = userPref.badge;
            event.deliveryDay = userPref.deliveryDay;
            event.frequencyMode = userPref.frequency;
            event.frequencyTime = userPref.frequencyTime;
            event.notificationType = userPref.notificationType;
            event.timeZoneArea = userPref.timeZoneArea;
          }
        });
      });
    });
    this.categories.forEach((category) => {
      category.events.forEach((event) => {
        this.originalEvents.push(_.clone(event));
      });
    });

    //4.fetching events to be shown when page loads
    let prevStateCategory = sessionStorage.getItem('categoryName');
    this.selectedCategory = prevStateCategory
      ? prevStateCategory
      : this.categories[0].categoryName;
    this.updateTimeZone();
    this.fetchEvents(this.selectedCategory);
    this.changedUserPrefEvents = [];
    this.cdr.detectChanges();
  }

  /**
   * This method is used to fetch only events based on the response of fetch user preference
   * @param category
   */
  fetchEvents(category: string) {
    this.events = [];

    let selectedCategory: any = this.categories.find(
      (v: any) => v.categoryName === category
    );
    selectedCategory?.events.forEach((event: any) => {
      let modifiedEvent = this.changedUserPrefEvents.find(
        (preferredEvent) => preferredEvent.id == event.id && event.canUserEdit
      );
      if (modifiedEvent) {
        event = modifiedEvent;
      }
      let eventObj = new Event();
      eventObj.id = event.id;
      eventObj.sMS = event.sMS;
      eventObj.frequencyTime = event.frequencyTime;
      eventObj.frequencyMode = event.frequencyMode;
      eventObj.eventName = event.eventName;
      eventObj.eventId = event.eventId;
      eventObj.eventDescription = event.eventDescription;
      eventObj.email = event.email;
      eventObj.deliveryDay = event.deliveryDay;
      eventObj.badge = event.badge;
      eventObj.notificationType = event.notificationType;
      eventObj.timeZoneArea = event.timeZoneArea;
      eventObj.canUserEdit = event.canUserEdit;
      this.events.push(eventObj);
    });
    this.selectedCategory = category;
    this.checkIsAllSelected();
    this.cdr.detectChanges();
  }

  /**
   * This method is used to check whether email options are true in all events
   */
  checkIsAllSelected() {
    if (this.events.find((event) => event.email == true) == undefined) {
      this.allComplete = false;
      this.isIndeterminate = false;
    } else {
      if (this.events.find((event) => event.email == false) != undefined) {
        this.allComplete = false;
        this.isIndeterminate = true;
      } else {
        this.allComplete = true;
        this.isIndeterminate = false;
      }
    }
  }

  /**
   * This method is used to set the checkbox state to selectall and fill the email options to true in all the events
   * @param state
   */
  setAll(state: any) {
    if (state) {
      this.checkExistingEventToSetAll(state);
      this.allComplete = true;
      this.isIndeterminate = false;
    } else {
      this.checkExistingEventToSetAll(state);
      this.allComplete = false;
      this.isIndeterminate = false;
    }
    if (this.changedUserPrefEvents.length >= 1) {
      this.notificationService.isChanged = true;
      this.checkChanges();
    }
    this.cdr.detectChanges();
  }

  checkExistingEventToSetAll(state) {
    this.events.forEach((event) => {
      let existingEvent = this.changedUserPrefEvents
        ? this.changedUserPrefEvents.find((e) => e.eventId == event.eventId)
        : undefined;
      if (existingEvent) {
        existingEvent.email = state;
        event.email = state;
        this.checkChanges();
      } else {
        if (event.canUserEdit) {
          event.email = state;
          this.changedUserPrefEvents.push(event);
        }
      }
    });
  }

  /**
   * This method is used to set email as true
   * @param event
   */
  setEmailEvent(event: Event) {
    this.notificationService.isChanged = true;
    let existingEvent = this.changedUserPrefEvents
      ? this.changedUserPrefEvents.find((e) => e.eventId == event.eventId)
      : undefined;
    let selectedEvent = undefined;

    this.categories.forEach((category) => {
      if(category.categoryName === this.selectedCategory){
        category.events.forEach((e) => {
          if(event.id === e.id)
          {
            selectedEvent = e;
          }
        });
      }
      
    });

    if (selectedEvent != null) {
      selectedEvent.email = !selectedEvent.email;
      if (existingEvent == undefined) {
        this.changedUserPrefEvents.push(selectedEvent);
      } else {
        existingEvent.email = selectedEvent.email;
      }
      this.checkIsAllSelected();
    }
    if (this.changedUserPrefEvents.length >= 1) {
      this.checkChanges();
    }
    this.fetchEvents(this.selectedCategory);
  }
  checkChanges() {
    var unchangedUserPrefEvent = [];
    this.changedUserPrefEvents.forEach((changedEvent) => {
      let previousEvent = this.originalEvents.find(
        (preEvent) => preEvent.eventId == changedEvent.eventId
      );
      if (
        previousEvent &&
        changedEvent.email == previousEvent.email &&
        changedEvent.frequencyMode == previousEvent.frequencyMode &&
        (_.isEmpty(changedEvent.frequencyTime) ? _.isEmpty(previousEvent.frequencyTime) : previousEvent.frequencyTime === changedEvent.frequencyTime) &&
        (_.isEmpty(changedEvent.deliveryDay) ? _.isEmpty(previousEvent.deliveryDay) : previousEvent.deliveryDay === changedEvent.deliveryDay)
      ) {
        unchangedUserPrefEvent.push(changedEvent);
      }
    });

    unchangedUserPrefEvent.forEach(unchangedEvent => {
      let unchangedEventIndex = this.changedUserPrefEvents.findIndex(
        (event) => event.eventId == unchangedEvent.eventId
      );
      this.changedUserPrefEvents.splice(unchangedEventIndex, 1);
    });
    this.disableSaveAndCancel =
      this.changedUserPrefEvents.length > 0 ? false : true;
    this.notificationService.isChanged = this.changedUserPrefEvents.length > 0;
  }

  /**
   * This method is used to move to home page
   */
  navigate() {
    this.route.navigateByUrl('/notification');
  }

  /**
   * This method is used to save changes done in preference
   */
  saveChanges() {
    this.userPrefList = [];
    this.disableSaveAndCancel = true;
    this.changedUserPrefEvents.forEach((preferredEvent: Event) => {
      let existingEvent = this.savedUserPrefArr.find(
        (event) => event.eventId == preferredEvent.eventId
      );
      let saveObj = {
        "id": existingEvent ? existingEvent.id : 0,
        "EventId": preferredEvent.eventId,
        "ApplicationId": this.applicationId,
        "UserId": this.userId,
        "Frequency": preferredEvent.frequencyMode,
        "FrequencyTime": (preferredEvent?.frequencyMode != "Immediate") ? preferredEvent.frequencyTime : null,
        "DeliveryDay": (preferredEvent?.frequencyMode == "Weekly") ? preferredEvent.deliveryDay : null,
        "SendEmail": preferredEvent.email,
        "SendSms": preferredEvent.sMS,
        "Badge": preferredEvent.badge,
        "NotificationType": preferredEvent.notificationType
      }
      this.userPrefList.push(saveObj);
    });
    sessionStorage.setItem('categoryName', this.selectedCategory);
    this.notificationService
      .saveUserPreference(this.userPrefList, this.userTimezoneOffset)
      .subscribe((response: Response) => {
        this.spinner.setPageOwnsLoader(true);
        this.notificationService
          .getSavedUserPref(this.applicationId, this.userTimezoneOffset)
          .subscribe({
            next: (response: any) => {
              this.events = [];
              this.changedUserPrefEvents = [];
              this.originalEvents = [];
              this.mergePref(response.data);
              this.disableSaveAndCancel = true;
              this.notificationService.isChanged = false;
              this.spinner.setPageOwnsLoader(false);
            },
            error: () => {
              this.cdr.detectChanges();
              this.spinner.setPageOwnsLoader(false);
            },
          });
      });
  }

  searchEvent(event: any) {
    if (event.keyCode == 13 || this.searchTerm == '') {
      this.searchValue = this.searchTerm;
      this.searchTerm != ''
        ? this.fetchSearchedEventsCount()
        : this.clearSearch();
    }
  }

  clearSearch() {
    this.searchTerm = '';
    this.searchValue = '';
    this.countedEvents = new Map<string, number>();
    this.fetchEvents(this.selectedCategory);
  }

  fetchSearchedEventsCount() {
    this.countedEvents = new Map<string, number>();
    this.categories.forEach((cat) => {
      let count = 0;
      cat.events.forEach((e: any) => {
        let eventDescription = e.eventDescription;
        this.searchValue = this.searchValue.replace(config.specialChar, '\\$1');
        const regex = new RegExp(this.searchValue, 'gi');
        const match = eventDescription.match(regex);
        if (match !== null && match[0] !== '') {
          count = count + match.length;
        }
        count > 0 ? this.countedEvents.set(cat.categoryName, count) : '';
      });
    });
    this.selectedCategory =
      this.countedEvents.size > 0
        ? this.countedEvents.keys().next().value
        : this.selectedCategory;
    this.fetchEvents(this.selectedCategory);
  }

  cancelChanges() {
    this.userPrefList = [];
    this.changedUserPrefEvents = [];
    this.notificationService.isChanged = false;
    this.disableSaveAndCancel = true;
    this.resetCategory();
    this.fetchEvents(this.selectedCategory);
  }

  resetCategory(){
    this.categories.forEach((cat) => {
      cat.events.forEach(event =>{
        let result = this.originalEvents.find((e)=>e.eventId == event.eventId);
          event.email = result.email;
          event.frequencyMode = result.frequencyMode;
          event.frequencyTime = result.frequencyTime;
          event.deliveryDay = result.deliveryDay;
      }) 
      }
    )}

  trackFunction(index: number, item: any) {
    return item.categoryName;
  }

  updateTimeZone() {
    let timeZone: string =
      new Date().toString().match(config.timeZoneRegEx) != null
        ? new Date().toString().match(config.timeZoneRegEx)[1]
        : null;
    this.categories.forEach((cat: Category) => {
      cat.events.forEach((eve: Event) => {
        eve.timeZoneArea = this.getTimeZoneString(timeZone);
      });
    });
  }

  getTimeZoneString(timeZone: string) {
    if (timeZone != null) {
      let seperator: string = timeZone?.includes('-') ? '-' : '+';
      let timeArray: string[] = timeZone?.split(seperator);
      let timeString: string = timeArray[1];
      timeString =
        timeString[0] + timeString[1] + ':' + timeString[2] + timeString[3];
      timeArray[1] = timeString;
      timeString = timeArray.join(' ' + seperator + ' ');
      return timeString;
    }
    return null;
  }

  convertTo12Hour(time: string): string {
    let parsedDate = new Date(`1970-01-01T${time}`);
    let formattedTime = parsedDate.toLocaleString('en-us', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });
    return formattedTime;
  }

  goToHome() {
    this.route.navigate(['/home']);
  }
}
